(() => {
  const revealItems = document.querySelectorAll('[data-bouquet-reveal]');
  const featuredSliders = document.querySelectorAll('[data-bouquet-featured-slider]');
  const coarsePointer = window.matchMedia('(pointer: coarse)');
  const compactViewport = window.matchMedia('(max-width: 989px)');

  const revealAllItems = () => {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  };

  const initFeaturedSliders = () => {
    featuredSliders.forEach((slider) => {
      const track = slider.querySelector('[data-bouquet-featured-track]');
      const slides = Array.from(slider.querySelectorAll('[data-bouquet-featured-slide]'));
      const previousButton = slider.querySelector('[data-bouquet-featured-prev]');
      const nextButton = slider.querySelector('[data-bouquet-featured-next]');

      if (!slides.length) {
        return;
      }

      const shuffledSlides = [...slides];
      for (let index = shuffledSlides.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffledSlides[index], shuffledSlides[randomIndex]] = [shuffledSlides[randomIndex], shuffledSlides[index]];
      }

      if (track) {
        shuffledSlides.forEach((slide) => track.appendChild(slide));
      }

      let activeIndex = 0;

      const setActiveSlide = (nextIndex) => {
        activeIndex = (nextIndex + shuffledSlides.length) % shuffledSlides.length;
        shuffledSlides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      setActiveSlide(0);

      if (shuffledSlides.length < 2) {
        [previousButton, nextButton].forEach((button) => {
          if (button) {
            button.hidden = true;
          }
        });
        return;
      }

      if (previousButton) {
        previousButton.addEventListener('click', () => setActiveSlide(activeIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => setActiveSlide(activeIndex + 1));
      }
    });
  };

  initFeaturedSliders();

  if (!revealItems.length) {
    return;
  }

  const showRandomTestimonialCard = (cards, activeCard) => {
    cards.forEach((card) => {
      const isActive = card === activeCard;
      card.hidden = !isActive;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  const shuffleTestimonialCards = (cards, lastCard) => {
    const queue = [...cards];

    for (let index = queue.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [queue[index], queue[randomIndex]] = [queue[randomIndex], queue[index]];
    }

    if (queue.length > 1 && queue[0] === lastCard) {
      const swapIndex = queue.findIndex((card) => card !== lastCard);
      [queue[0], queue[swapIndex]] = [queue[swapIndex], queue[0]];
    }

    return queue;
  };

  const getLastSessionTestimonialCard = (group, cards) => {
    try {
      const key = group.dataset.randomTestimonialId;
      const lastCardId = key ? window.sessionStorage.getItem(`bouquet-last-testimonial-${key}`) : null;

      return cards.find((card) => card.dataset.randomTestimonialCard === lastCardId) || null;
    } catch (_error) {
      return null;
    }
  };

  const saveLastSessionTestimonialCard = (group, activeCard) => {
    try {
      const key = group.dataset.randomTestimonialId;

      if (key && activeCard?.dataset.randomTestimonialCard) {
        window.sessionStorage.setItem(`bouquet-last-testimonial-${key}`, activeCard.dataset.randomTestimonialCard);
      }
    } catch (_error) {
      // Session storage can be unavailable in strict privacy modes.
    }
  };

  document.querySelectorAll('[data-random-testimonial]').forEach((group) => {
    const cards = Array.from(group.querySelectorAll('[data-random-testimonial-card]'));

    if (!cards.length) {
      return;
    }

    const rotationDelay = Math.max(Number(group.dataset.randomTestimonialInterval) || 5000, 3000);
    let lastCard = getLastSessionTestimonialCard(group, cards) || group.querySelector('[data-random-testimonial-card].is-active');
    let queue = shuffleTestimonialCards(cards, lastCard);

    lastCard = queue.shift() || cards[0];
    showRandomTestimonialCard(cards, lastCard);
    saveLastSessionTestimonialCard(group, lastCard);

    if (cards.length < 2) {
      return;
    }

    window.setInterval(() => {
      if (!queue.length) {
        queue = shuffleTestimonialCards(cards, lastCard);
      }

      lastCard = queue.shift();
      showRandomTestimonialCard(cards, lastCard);
      saveLastSessionTestimonialCard(group, lastCard);
    }, rotationDelay);
  });

  if (coarsePointer.matches || compactViewport.matches) {
    revealAllItems();
    return;
  }

  const revealVisibleItems = () => {
    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        item.classList.add('is-visible');
      }
    });
  };

  if (!('IntersectionObserver' in window)) {
    revealAllItems();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
  );

  revealItems.forEach((item) => observer.observe(item));
  revealVisibleItems();
  window.addEventListener('scroll', revealVisibleItems, { passive: true });
  window.addEventListener('resize', revealVisibleItems);
})();
